import Swal from 'sweetalert2';

const escapeHtml = (value) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

/**
 * Confirmation before turning a client's monthly withholding reporting (Clients/UpdateWithholdingReporting)
 * on or off. Styled by the withholding-reporting-swal-* rules in Main.module.scss.
 * @returns {Promise<boolean>} whether the user confirmed.
 */
export const confirmWithholdingReporting = async ({ t, direction, clientName, monthLabel, enable }) => {
  const action = enable
    ? t('WithholdingReportingConfirmEnableAction')
    : t('WithholdingReportingConfirmDisableAction');
  const monthLine = t('WithholdingReportingConfirmMonth', { month: monthLabel });

  const result = await Swal.fire({
    title: t('WithholdingReportingConfirmTitle'),
    html: `
      <div class="withholding-reporting-swal-content" dir="${direction}">
        <p class="withholding-reporting-swal-action">${action}</p>
        <p class="withholding-reporting-swal-client" dir="auto">${escapeHtml(clientName)}</p>
        <p class="withholding-reporting-swal-month">${monthLine}</p>
      </div>
    `,
    icon: enable ? 'info' : 'warning',
    showCancelButton: true,
    confirmButtonText: t('Yes'),
    cancelButtonText: t('Cancel'),
    confirmButtonColor: '#304FFF',
    cancelButtonColor: '#64748b',
    reverseButtons: direction === 'rtl',
    focusCancel: true,
    customClass: {
      popup: 'withholding-reporting-swal-popup',
      title: 'withholding-reporting-swal-title',
      confirmButton: 'withholding-reporting-swal-confirm',
      cancelButton: 'withholding-reporting-swal-cancel',
      icon: enable ? 'withholding-reporting-swal-icon-enable' : 'withholding-reporting-swal-icon-disable',
    },
    width: 440,
    padding: '1.75rem 1.5rem',
    didOpen: (popup) => {
      popup.setAttribute('dir', direction);
    },
  });
  return result.isConfirmed;
};

/** Months (1-12) of a withholding period: one month, or both months of a bi-monthly period. */
export const withholdingPeriodMonths = (startMonth, endMonth) => {
  const months = [];
  for (let m = startMonth; m <= endMonth; m += 1) months.push(m);
  return months;
};
